var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 18,
    height: 18,
    transform: "translate(60 171)",
    fill: "#9babc5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_30",
    "data-name": "Mask Group 30",
    transform: "translate(-60 -171)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(60 171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M9,18a8.972,8.972,0,0,1-7.8-4.482A8.841,8.841,0,0,1,0,9,8.879,8.879,0,0,1,2.32,2.988q.053-.053.2-.211t.246-.255a1.089,1.089,0,0,1,.264-.185.728.728,0,0,1,.343-.088,1.081,1.081,0,0,1,.791.334,1.081,1.081,0,0,1,.334.791,1.765,1.765,0,0,1-.062.492.694.694,0,0,1-.132.281l-.053.088A6.7,6.7,0,0,0,2.777,6.4,6.535,6.535,0,0,0,2.25,9a6.61,6.61,0,0,0,.905,3.384,6.7,6.7,0,0,0,2.461,2.461,6.777,6.777,0,0,0,6.768,0,6.7,6.7,0,0,0,2.461-2.461,6.754,6.754,0,0,0,.378-5.994,6.808,6.808,0,0,0-1.459-2.171,1.156,1.156,0,0,1-.264-.844,1.081,1.081,0,0,1,.334-.791,1.081,1.081,0,0,1,.791-.334.8.8,0,0,1,.237.035,1.235,1.235,0,0,1,.185.07.9.9,0,0,1,.185.141,1.7,1.7,0,0,1,.149.149q.035.044.158.185t.141.158a8.949,8.949,0,0,1,1.608,9.51,8.806,8.806,0,0,1-4.79,4.79A8.829,8.829,0,0,1,9,18ZM9,9A1.111,1.111,0,0,1,7.875,7.875V1.125a1.073,1.073,0,0,1,.334-.8A1.106,1.106,0,0,1,9.009,0,1.077,1.077,0,0,1,9.8.325a1.087,1.087,0,0,1,.325.8v6.75A1.111,1.111,0,0,1,9,9Z",
    fill: "#9babc5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.54484f1de59d55e94bb42a2fb0f4301c.svg";
export { ForwardRef as ReactComponent };